module.exports = __webpack_public_path__ + "img/logoblue.040b943d.png";